export const getError = (error) => {
  const errorMessage = "API Error, please try again.";
  
  if (error.name === "Fetch User") {
    return error.message;
  }

  if (!error.response) {
    console.log(error);
    console.error(`API ${error.config.url} not found`);
    return errorMessage;
  }
  // if (process.env.NODE_ENV === "development") {
  //   console.error(error.response.data);
  //   console.error(error.response.status);
  //   console.error(error.response.headers);
  // }
  if (error.response.data && error.response.data.errors) {
     return error.response.data.errors;
  }

  if (error.response.data && error.response.data.error) {
     return error.response.data.error;
  }

  return errorMessage;
};

/**
 * Apply company theme colors to CSS variables
 * This function reads companyInformation from localStorage or accepts it as a parameter
 * and applies the theme colors immediately to the document root
 * 
 * @param {Object|null} companyInfo - Optional company information object. If not provided, reads from localStorage
 * @param {boolean} dispatchEvent - Whether to dispatch a custom event for same-tab listeners (default: true)
 */
export const applyThemeColors = (companyInfo = null, dispatchEvent = true) => {
  try {
    // Get company information from parameter or localStorage
    let color_client = companyInfo;
    
    if (!color_client) {
      const storedInfo = localStorage.getItem("companyInformation");
      if (storedInfo) {
        color_client = JSON.parse(storedInfo);
      }
    }

    // Get root element for CSS variables
    const root = document.documentElement;

    // Apply default colors if no company information or invalid data
    if (!color_client || 
        color_client.length === 0 || 
        color_client.length === 'undefined' ||
        !color_client.hex_color) {
      root.style.setProperty('--color_orange', '#FF9500');
      root.style.setProperty('--primary_color', '#FF9500');
      root.style.setProperty('--secondary_color', '#1A191C');
    } else {
      // Apply company-specific colors
      root.style.setProperty('--color_orange', color_client.hex_color);
      root.style.setProperty('--primary_color', color_client.hex_color);
      root.style.setProperty('--secondary_color', color_client.secondary_hex_color || '#1A191C');
    }

    // Dispatch custom event for same-tab listeners (storage event only fires for other tabs)
    if (dispatchEvent && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('companyInformationUpdated'));
    }
  } catch (error) {
    console.error('Error applying theme colors:', error);
    // Fallback to default colors on error
    const root = document.documentElement;
    root.style.setProperty('--color_orange', '#FF9500');
    root.style.setProperty('--primary_color', '#FF9500');
    root.style.setProperty('--secondary_color', '#1A191C');
  }
};